/**
 * Bottom-right Operations control. Shown only on bound pages (CRM first)
 * while the pane is closed. Portaled to body so it is not a flex dock sibling.
 */

import React from 'react';
import { createPortal } from 'react-dom';
import { SparklesIcon } from '@heroicons/react/24/outline';
import { useLanguage } from '@/state/language/LanguageProvider';
import { useOperationsPane } from './operationsContext';

export const OperationsFab: React.FC = () => {
  const { t } = useLanguage();
  const { toggle } = useOperationsPane();

  const button = (
    <button
      type="button"
      onClick={toggle}
      className="fixed z-40 bottom-4 right-4 flex h-11 w-11 items-center justify-center rounded-full border border-[var(--color-border)] bg-[var(--color-accent-bg)] text-[var(--color-accent-text)] shadow-md hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-accent-bg)]"
      title={t('operations.pane.open')}
      aria-label={t('operations.pane.open')}
    >
      <SparklesIcon className="h-5 w-5" />
    </button>
  );

  if (typeof document === 'undefined') return button;
  return createPortal(button, document.body);
};
